import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const CustomNumber = ({ inputRef, onChange, ...other }) => (
  <NumberFormat
    {...other}
    ref={inputRef}
    onValueChange={({ value }) => onChange({ target: { value } })}
  />
);

CustomNumber.propTypes = {
  inputRef: PropTypes.element,
  onChange: PropTypes.func,
};

export default CustomNumber;



// WEBPACK FOOTER //
// ./src/core/formatting/CustomNumber.jsx